import * as React from 'react';
import { Tab } from 'react-bootstrap';
import { Menu } from 'moduleBase/types/Menu';
import { FC, useState } from 'react';
import { Tabs } from 'moduleBase/modules/menu/components/mobile/Tabs';
import { TabsContent } from 'moduleBase/modules/menu/components/mobile/TabsContent';
import { MenuAdditionalData } from 'moduleBaseMenu/types/MenuAdditionalData';

type MenuPanelTabsProps = {
  menu: Menu<MenuAdditionalData>,
  hide: () => void
};

const MenuPanelTabs: FC<MenuPanelTabsProps> = ({ menu, hide }) => {
  const [activeTab, setActiveTab] = useState(menu.activeBlock);
  const blocks = menu.blocks.filter((block) => !block.section);

  return (
    <Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={setActiveTab}>
      <Tabs blocks={blocks} tools={menu.tools} faq={menu.faq} />
      <TabsContent
        blocks={blocks}
        hide={hide}
        supportInfo={menu.supportInfo}
        tools={menu.tools}
        faq={menu.faq}
      />
    </Tab.Container>
  );
};

export { MenuPanelTabs };
